module.exports = __webpack_public_path__ + "static/media/HalisR-Regular.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/HalisR-Regular.otf
// module id = 887
// module chunks = 0